import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminForm from "./AdminForm";
import apiClient from "../../utils/apiClient";
import CommonToaster from "../Common/CommonToaster";

const EditAdminPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });
  const navigate = useNavigate();

  // Fetch admin data + admins list
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [adminRes, listRes] = await Promise.all([
          apiClient.get(`/admins/${id}`),
          apiClient.get("/admins/list"),
        ]);
        setAdminData(adminRes.data.admin);
        setAdmins(listRes.data.admins || []);
      } catch (err) {
        setToast({
          show: true,
          message: err?.response?.data?.message || "Failed to load admin details.",
          type: "error",
        });
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  const handleUpdateAdmin = async (form) => {
    setSaving(true);
    try {
      const { data } = await apiClient.put(`/admins/${id}`, form);
      setToast({ show: true, message: data.message, type: "success" });
      setTimeout(() => navigate("/admins"), 1000);
    } catch (err) {
      setToast({
        show: true,
        message: err?.response?.data?.message || "Failed to update admin.",
        type: "error",
      });
    }
    setSaving(false);
  };

  return (
    <>
      {loading ? (
        <div className="admins-loading">Loading...</div>
      ) : adminData ? (
        <AdminForm
          mode="edit"
          initialData={adminData}
          onSubmit={handleUpdateAdmin}
          loading={saving}
          onCancel={() => navigate(`/admins/${id}`)}
          admins={admins}
        />
      ) : (
        <div style={{ textAlign: "center", padding: "3rem", color: "var(--text-tertiary)" }}>
          Admin not found.
        </div>
      )}
      <CommonToaster
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast((t) => ({ ...t, show: false }))}
      />
    </>
  );
};

export default EditAdminPage;
